<template>
  <div class="margin-top-10 h-100">
    <div class="display-flex" style="max-height: 85%">
      <div style="flex-basis: 49.5%;margin-right: 0.5%">
        <el-row  style="height: calc(100% - 30px)">
          <div class="text-left">用户列表：</div>
          <el-table
            ref="userTable"
            :data="userList"
            class="table no-row-border"
             size="mini"
            @selection-change="selectUser"
            style="width: 100%;max-height: 100%;margin-top: 10px;overflow-y: auto">
            <el-table-column
              type="selection"
              width="29">
            </el-table-column>
            <el-table-column
              align="center"
              label="用户名"
              prop="name">
            </el-table-column>
            <el-table-column
              align="center"
              label="工号"
              prop="number">
            </el-table-column>
            <el-table-column
              align="center"
              label="卡号"
              prop="card">
            </el-table-column>
            <el-table-column
              align="center"
              label="部门"
              prop="section">
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <div class="flex-50">
        <el-row style="height: calc(100% - 30px)">
          <div class="text-left">门列表：</div>
          <el-table
            :data="doorList"
            ref="doorTable"
            size="mini"
            border
            class="table no-row-border"
            @selection-change="selectDoor"
            style="width: 100%;max-height: 100%;margin-top: 10px;overflow-y: auto">
            <el-table-column
              type="selection"
              width="29">
            </el-table-column>
            <el-table-column
              align="center"
              label="门ID"
              prop="did">
            </el-table-column>
            <el-table-column
              align="center"
              label="门名称"
              prop="name">
            </el-table-column>
            <el-table-column
              align="center"
              label="控制器"
              prop="devSn">
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </div>
    <div class="margin-top-15">
      <el-button size="mini" type="primary" @touchstart="authorizeOperation('addAuthority')"  @click="authorizeOperation('addAuthority')">修改权限</el-button>
      <el-button size="mini" type="danger" @touchstart="authorizeOperation('delAuthority')" @click="authorizeOperation('delAuthority')">删除权限</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Authorize",
  props: ['userList','doorList'],
  data() {
    return{
      selectData: {
        user: [],
        door: [],
      }
    }
  },
  methods: {
    selectUser(val){
      this.selectData.user = val
    },
    selectDoor(val){
      this.selectData.door = val
    },
    authorizeOperation(command){
      if (this.selectData.user.length < 1){
        this.$message.error("请选择用户!")
        return false
      }
      if (this.selectData.door.length < 1){
        this.$message.error("请选择门!")
        return false
      }
      this.$emit("sendWebsocket",command,this.selectData)
    },
    clearSelection(){
      this.$refs.userTable.clearSelection()
      this.$refs.doorTable.clearSelection()
    },
  }
}
</script>

<style scoped>

</style>
